import Loading from '@/components/Loading'
import NotFound from '@/pages/NotFound'
import { routeTree } from '@/routes/routeTree.tsx'
import { createRouter, RouterProvider } from '@tanstack/react-router'

const router = createRouter({
  routeTree,
  defaultNotFoundComponent: NotFound,
  defaultPendingComponent: Loading,
  defaultPendingMs: 0,
  defaultStaleTime: 0,
  context: {},
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof routeTree
  }
}

export default function Router() {
  return <RouterProvider router={router} context={{}} />
}
